<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page05">
<p class="dedicationText"><em class="italic">This book is dedicated to my loving and insightful wife, Dr. Joan Berzoff,<br/> and our two stalwart sons, Zeke and Jake</em></p>
</a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003dedicationpage.vue?bb7b2334